import '@mrhenry/wp--bugsnag-config';

/* Modules */
import './modules/artwork-overlay.ts';
import './modules/input-sink.ts';
import './modules/mr-carousel.ts';
import './modules/navigation-overlay.ts';

import { PrivacyControls, initMenuButtons } from '@mrhenry/wp--mr-interactive';

PrivacyControls.setupPrivacyAwareEmbedders();
PrivacyControls.setupPrivacyAwareGTM();

requestAnimationFrame( () => {
	initMenuButtons();
} );
